import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "participant__user-name" }
const _hoisted_3 = {
  key: 0,
  class: "participant__user-badge"
}
const _hoisted_4 = {
  key: 1,
  class: "participant__user-badge"
}
const _hoisted_5 = {
  key: 2,
  class: "participant__user-badge"
}
const _hoisted_6 = {
  key: 3,
  class: "participant__user-badge"
}
const _hoisted_7 = ["title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_IconPhoneDialOutline = _resolveComponent("IconPhoneDialOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconPhoneHangupOutline = _resolveComponent("IconPhoneHangupOutline")
  const _component_DialpadPanel = _resolveComponent("DialpadPanel")
  const _component_IconAccountMinusOutline = _resolveComponent("IconAccountMinusOutline")
  const _component_IconAccountPlusOutline = _resolveComponent("IconAccountPlusOutline")
  const _component_IconLockOutline = _resolveComponent("IconLockOutline")
  const _component_NcActionText = _resolveComponent("NcActionText")
  const _component_IconAccountOutline = _resolveComponent("IconAccountOutline")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconCrownOutline = _resolveComponent("IconCrownOutline")
  const _component_IconEmailOutline = _resolveComponent("IconEmailOutline")
  const _component_IconBellOutline = _resolveComponent("IconBellOutline")
  const _component_IconPhoneInTalkOutline = _resolveComponent("IconPhoneInTalkOutline")
  const _component_IconPhonePausedOutline = _resolveComponent("IconPhonePausedOutline")
  const _component_IconMicrophoneOutline = _resolveComponent("IconMicrophoneOutline")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_IconContentCopy = _resolveComponent("IconContentCopy")
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")
  const _component_IconLockReset = _resolveComponent("IconLockReset")
  const _component_IconLockOpenVariantOutline = _resolveComponent("IconLockOpenVariantOutline")
  const _component_IconPencilOutline = _resolveComponent("IconPencilOutline")
  const _component_IconTrashCanOutline = _resolveComponent("IconTrashCanOutline")
  const _component_ParticipantPermissionsEditor = _resolveComponent("ParticipantPermissionsEditor")
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")
  const _component_NcTextArea = _resolveComponent("NcTextArea")
  const _component_NcDialog = _resolveComponent("NcDialog")
  const _component_NcListItem = _resolveComponent("NcListItem")

  return (_openBlock(), _createBlock(_component_NcListItem, {
    name: $options.computedName,
    "data-nav-id": $options.participantNavigationId,
    class: _normalizeClass(["participant", { 'participant--offline': $options.isOffline }]),
    "aria-label": $options.participantAriaLabel,
    "actions-aria-label": $options.participantSettingsAriaLabel,
    "force-display-actions": "",
    "force-menu": ""
  }, _createSlots({
    icon: _withCtx(() => [
      (_openBlock(), _createBlock(_component_AvatarWrapper, {
        id: $props.participant.actorId,
        key: $props.participant.attendeeId,
        token: $setup.token,
        name: $options.displayName,
        source: $props.participant.actorType,
        "disable-tooltip": "",
        "show-user-status": $props.showUserStatus,
        "preloaded-user-status": $options.preloadedUserStatus,
        highlighted: $options.isSpeakingStatusAvailable && $options.isParticipantSpeaking,
        offline: $options.isOffline
      }, null, 8, ["id", "token", "name", "source", "show-user-status", "preloaded-user-status", "highlighted", "offline"]))
    ]),
    name: _withCtx(() => [
      _createElementVNode("span", {
        class: "participant__user",
        title: $options.userNameTitle
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString($options.computedName), 1),
        ($options.showModeratorLabel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString($options.t('spreed', 'moderator')) + ")", 1))
          : _createCommentVNode("", true),
        ($options.isBridgeBotUser)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString($options.t('spreed', 'bot')) + ")", 1))
          : _createCommentVNode("", true),
        ($options.isGuestActor || $options.isEmailActor)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString($options.t('spreed', 'guest')) + ")", 1))
          : _createCommentVNode("", true),
        (!$options.isSelf && $options.isLobbyEnabled && !$options.canSkipLobby)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString($options.t('spreed', 'in the lobby')) + ")", 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1)
    ]),
    "extra-actions": _withCtx(() => [
      ($setup.isInCall && $options.canBeModerated && $options.isPhoneActor)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!$props.participant.inCall)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 0,
                  variant: "success",
                  "aria-label": $options.t('spreed', 'Dial out phone'),
                  title: $options.t('spreed', 'Dial out phone'),
                  disabled: $data.disabled,
                  onClick: $options.dialOutPhoneNumber
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconPhoneDialOutline, { size: 20 })
                  ]),
                  _: 1
                }, 8, ["aria-label", "title", "disabled", "onClick"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_NcButton, {
                    variant: "error",
                    "aria-label": $options.t('spreed', 'Hang up phone'),
                    title: $options.t('spreed', 'Hang up phone'),
                    disabled: $data.disabled,
                    onClick: $options.hangupPhoneNumber
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconPhoneHangupOutline, { size: 20 })
                    ]),
                    _: 1
                  }, 8, ["aria-label", "title", "disabled", "onClick"]),
                  _createVNode(_component_DialpadPanel, {
                    disabled: $data.disabled,
                    container: "#tab-participants",
                    dialing: "",
                    onDialType: $options.dialType
                  }, null, 8, ["disabled", "onDialType"])
                ], 64))
          ], 64))
        : ($options.callIcon)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.callIcon.icon), {
              key: 1,
              class: "participant__call-state",
              title: $options.callIcon.title,
              size: $options.callIcon.size
            }, null, 8, ["title", "size"]))
          : _createCommentVNode("", true),
      ($options.showToggleLobbyAction)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            ($options.canSkipLobby)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 0,
                  variant: "tertiary",
                  title: $options.t('spreed', 'Move back to lobby'),
                  "aria-label": $options.t('spreed', 'Move back to lobby'),
                  onClick: _cache[0] || (_cache[0] = $event => ($options.setLobbyPermission(false)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconAccountMinusOutline, { size: 20 })
                  ]),
                  _: 1
                }, 8, ["title", "aria-label"]))
              : (_openBlock(), _createBlock(_component_NcButton, {
                  key: 1,
                  variant: "tertiary",
                  title: $options.t('spreed', 'Move to conversation'),
                  "aria-label": $options.t('spreed', 'Move to conversation'),
                  onClick: _cache[1] || (_cache[1] = $event => ($options.setLobbyPermission(true)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconAccountPlusOutline, { size: 20 })
                  ]),
                  _: 1
                }, 8, ["title", "aria-label"]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    extra: _withCtx(() => [
      ($options.showPermissionsOptions && $data.permissionsEditor)
        ? (_openBlock(), _createBlock(_component_ParticipantPermissionsEditor, {
            key: 0,
            "actor-id": $props.participant.actorId,
            "close-after-click": "",
            participant: $props.participant,
            token: $setup.token,
            onClose: _cache[4] || (_cache[4] = $event => ($data.permissionsEditor = false))
          }, null, 8, ["actor-id", "participant", "token"]))
        : _createCommentVNode("", true),
      ($options.canBeModerated && $data.isRemoveDialogOpen)
        ? (_openBlock(), _createBlock(_component_NcDialog, {
            key: 1,
            open: $data.isRemoveDialogOpen,
            "onUpdate:open": _cache[8] || (_cache[8] = $event => (($data.isRemoveDialogOpen) = $event)),
            name: $options.removeParticipantLabel
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_NcButton, {
                variant: "tertiary",
                disabled: $data.isLoading,
                onClick: _cache[7] || (_cache[7] = $event => ($data.isRemoveDialogOpen = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.t('spreed', 'Dismiss')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_NcButton, {
                variant: "error",
                disabled: $data.isLoading || !!$options.maxLengthWarning,
                onClick: $options.removeParticipant
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.t('spreed', 'Remove')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString($options.removeDialogMessage), 1),
              ($options.showBanOption)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_NcCheckboxRadioSwitch, {
                      modelValue: $data.isBanParticipant,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.isBanParticipant) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Also ban from this conversation')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    ($data.isBanParticipant)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($data.isBanParticipant)
                            ? (_openBlock(), _createBlock(_component_NcTextArea, {
                                key: 0,
                                modelValue: $data.internalNote,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.internalNote) = $event)),
                                class: "participant-dialog__input",
                                resize: "vertical",
                                label: $options.t('spreed', 'Internal note (reason to ban)'),
                                error: !!$options.maxLengthWarning,
                                "helper-text": $options.maxLengthWarning
                              }, null, 8, ["modelValue", "label", "error", "helper-text"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["open", "name"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    ($options.statusMessage)
      ? {
          name: "subname",
          fn: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["participant__status", { 'participant__status--highlighted': $options.isParticipantSpeaking }]),
              title: $options.statusMessage
            }, _toDisplayString($options.statusMessage), 11, _hoisted_7)
          ]),
          key: "0"
        }
      : undefined,
    ($options.showParticipantActions && $options.actionIcon)
      ? {
          name: "actions-icon",
          fn: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent($options.actionIcon), { size: 20 }))
          ]),
          key: "1"
        }
      : undefined,
    ($options.showParticipantActions)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            ($options.attendeePin)
              ? (_openBlock(), _createBlock(_component_NcActionText, {
                  key: 0,
                  name: $options.t('spreed', 'Dial-in PIN')
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconLockOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.attendeePin), 1)
                  ]),
                  _: 1
                }, 8, ["name"]))
              : _createCommentVNode("", true),
            ($options.canBeDemoted)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: "demote-moderator",
                  "close-after-click": "",
                  onClick: $options.demoteFromModerator
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconAccountOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Demote from moderator')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : ($options.canBePromoted)
                ? (_openBlock(), _createBlock(_component_NcActionButton, {
                    key: "promote-moderator",
                    "close-after-click": "",
                    onClick: $options.promoteToModerator
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconCrownOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Promote to moderator')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
            ($options.canBeModerated && $options.isEmailActor)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: "resend-invitation",
                  "close-after-click": "",
                  onClick: $options.resendInvitation
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconEmailOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Resend invitation')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($options.canSendCallNotification)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: "send-call-notification",
                  "close-after-click": "",
                  onClick: $options.sendCallNotification
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconBellOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Send call notification')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($options.canBeModerated && $options.isPhoneActor)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (!$options.conversation.hasCall && !$setup.isInCall && !$props.participant.callId)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "dial-out-phone-number",
                        "close-after-click": "",
                        onClick: $options.dialOutPhoneNumber
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconPhoneDialOutline, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Dial out phone number')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : ($setup.isInCall && $props.participant.callId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          ($options.phoneMuteState === 'hold')
                            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                key: "resume-call-phone-number",
                                "close-after-click": "",
                                onClick: $options.unmutePhoneNumber
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_IconPhoneInTalkOutline, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Resume call for phone number')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_NcActionButton, {
                                  key: "hold-call-phone-number",
                                  "close-after-click": "",
                                  onClick: $options.holdPhoneNumber
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_IconPhonePausedOutline, { size: 20 })
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Put phone number on hold')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                ($options.phoneMuteState === 'muted')
                                  ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                      key: "unmute-call-phone-number",
                                      "close-after-click": "",
                                      onClick: $options.unmutePhoneNumber
                                    }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_IconMicrophoneOutline, { size: 20 })
                                      ]),
                                      default: _withCtx(() => [
                                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Unmute phone number')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_NcActionButton, {
                                      key: "mute-call-phone-number",
                                      "close-after-click": "",
                                      onClick: $options.mutePhoneNumber
                                    }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_NcIconSvgWrapper, {
                                          svg: $setup.IconMicrophoneOffOutline,
                                          size: 20
                                        }, null, 8, ["svg"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Mute phone number')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true),
                  _createVNode(_component_NcActionButton, {
                    key: "copy-phone-number",
                    "close-after-click": "",
                    onClick: $options.copyPhoneNumber
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconContentCopy, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy phone number')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true),
            ($options.canBeModerated && $options.isPhoneActor && $options.showPermissionsOptions)
              ? (_openBlock(), _createBlock(_component_NcActionSeparator, { key: 6 }))
              : _createCommentVNode("", true),
            ($options.showPermissionsOptions)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                  ($options.hasNonDefaultPermissions)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "reset-permissions",
                        "close-after-click": "",
                        onClick: $options.applyDefaultPermissions
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconLockReset, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Reset custom permissions')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_NcActionButton, {
                    key: "grant-all-permissions",
                    "close-after-click": "",
                    onClick: $options.grantAllPermissions
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconLockOpenVariantOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Grant all permissions')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_NcActionButton, {
                    key: "remove-all-permissions",
                    "close-after-click": "",
                    onClick: $options.removeAllPermissions
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconLockOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Remove all permissions')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_NcActionButton, {
                    key: "edit-permissions",
                    "close-after-click": "",
                    onClick: _cache[2] || (_cache[2] = $event => ($data.permissionsEditor = true))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconPencilOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Edit permissions')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            ($options.showPermissionsOptions && $options.canBeModerated)
              ? (_openBlock(), _createBlock(_component_NcActionSeparator, { key: 8 }))
              : _createCommentVNode("", true),
            ($options.canBeModerated)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: "remove-participant",
                  class: "critical",
                  "close-after-click": "",
                  onClick: _cache[3] || (_cache[3] = $event => ($data.isRemoveDialogOpen = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconTrashCanOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.removeParticipantLabel), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          key: "2"
        }
      : undefined
  ]), 1032, ["name", "data-nav-id", "class", "aria-label", "actions-aria-label"]))
}